var map = {
	"./CustomPackage/components": "EqaG",
	"./GlobalBPOCore/components": "Olif",
	"./SelfService/components": "JHCd",
	"./SteelOApp/components": "xidM"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JISj";


//////////////////
// WEBPACK FOOTER
// ./src/customization ^\.\/.*\/components$
// module id = JISj
// module chunks = 0